module.exports = __webpack_public_path__ + "static/media/solution-3.82b3192e.png";